import { Weekday } from '@occc/graphql';
import { Box } from '@occc-app/design-system';

import { IconButton } from '../../../../inputs/icon-button/icon-button.component';
import { KeyboardArrowLeftIcon, KeyboardArrowRightIcon } from '../../../../../icons/importedIcons';
import { Typography } from '../../../typography/typography.component';
import { CALENDAR_GRID_DAYS } from '../../constants';

type CalendarGridDayHeaderProps = {
  day?: Weekday;
  textColor?: string;
  onNextDayClick?: () => void;
  onPrevDayClick?: () => void;
};

export const CalendarGridDayHeader = ({
  day = Weekday.Sunday,
  textColor,
  onNextDayClick,
  onPrevDayClick,
}: CalendarGridDayHeaderProps) => {
  return (
    <Box px={1} display='flex' flexDirection='row' alignItems='center'>
      {!!onPrevDayClick && (
        <IconButton size='small' onClick={onPrevDayClick} sx={{ color: textColor }}>
          <KeyboardArrowLeftIcon fontSize='small' />
        </IconButton>
      )}
      <Typography
        px={1}
        variant='body2'
        fontWeight={500}
        sx={{ textTransform: 'uppercase' }}
        color={textColor}
      >
        {CALENDAR_GRID_DAYS[day]}
      </Typography>
      {!!onNextDayClick && (
        <IconButton size='small' onClick={onNextDayClick} sx={{ color: textColor }}>
          <KeyboardArrowRightIcon fontSize='small' />
        </IconButton>
      )}
    </Box>
  );
};
